// TreeViewEdit.js

import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "jstree";
import { collection, getDocs, query, where, setDoc } from "firebase/firestore";
import { db } from "../../config/firebaseConfig";
import "./treeViewEdit.css";
import { Button } from "../../components/ui/button";
import { useNavigate } from "react-router-dom";
import { useTreeView } from "../../context/treeViewContext";

const TreeViewEdit = () => {
  const treeRef = useRef(null);
  const [treeData, setTreeData] = useState([]);
  const [selectedID, setSelectedID] = useState(null);
  const [selectedNode, setSelectedNode] = useState(null);
  const [isActionButtonDisabled, setIsActionButtonDisabled] = useState(true);

  const navigate = useNavigate();
  const currentProjectID = localStorage.getItem("currentProjectID");

  // 選択されたノードを state にセット
  const setSelectedNodeID = (id, node) => {
    setSelectedID(id);
    setSelectedNode(node);
  };

  // ノードがカテゴリではない（type === "false"）ときだけ編集ボタンを有効にする
  useEffect(() => {
    // setIsActionButtonDisabled(selectedNode?.type !== "false");
    setIsActionButtonDisabled(false);
  }, [selectedNode]);

  // 初回マウント時にデータを取得してツリーを構築
  useEffect(() => {
    fetchAndBuildTree();
  }, []);

  // Firestoreからデータを取得し、ツリー形式に整形
  const fetchAndBuildTree = async () => {
    const q = query(
      collection(db, "00_DeviceMasterTable"),
      where("projectID", "==", currentProjectID)
    );
    const snapshot = await getDocs(q);
    const rawData = snapshot.docs.map((doc) => doc.data());

    const filteredData = rawData
      .filter((item) => !item.deleted)
      .map((item) => ({
        ...item,
        name: item.name || "名称未設定",
        parentID: item.parentID || "",
        sortIndex: item.sortIndex ?? 9999,
      }));

    const sortedNodes = [];
    const buildSortedTree = (parentID) => {
      const children = filteredData
        .filter((item) => item.parentID === parentID)
        .sort((a, b) => a.sortIndex - b.sortIndex);

      children.forEach((item) => {
        sortedNodes.push({
          id: "master_" + item.masterID,
          parent: item.parentID ? "master_" + item.parentID : "#",

          // text: `${item.name}, ${item.parentID}, ${item.sortIndex}`,　//ネーム以外の情報も表示
          text: `${item.name}`, //ネームのみ表示

          type: item.isCategory || "unclassified",
        });
        buildSortedTree(item.masterID);
      });
    };

    buildSortedTree("");
    setTreeData(sortedNodes);
  };

  // jsTree を初期化
  useEffect(() => {
    if (treeData.length === 0) return;

    const $tree = $(treeRef.current);
    $tree.jstree("destroy").empty();

    $tree.jstree({
      core: {
        check_callback: true,
        data: treeData,
      },
      types: {
        category: { icon: "fa-solid fa-folder" },
        device: { icon: "fa-solid fa-microchip" },
        unclassified: { icon: "fa-solid fa-circle" },
      },
      plugins: ["types", "dnd", "state", "wholerow"],
    });

    // ノード選択イベント
    $tree.on("select_node.jstree", (e, data) => {
      if (data?.node) {
        const selectedID = data.node.id;
        const selectedNode = data.node;
        console.log("✅ selectedID:", selectedID);
        setSelectedNodeID(selectedID, selectedNode);
      }
    });

    // クリーンアップ
    return () => {
      $tree.off("select_node.jstree");
    };
  }, [treeData]);

  // 並び順保存
  const handleSaveOrder = async () => {
    const treeInstance = $(treeRef.current).jstree(true);
    const allNodes = treeInstance.get_json("#", { flat: true });

    const updates = allNodes.map((node, index) => {
      const masterID = node.id?.replace("master_", "");
      return {
        id: masterID,
        parentID: node.parent === "#" ? "" : node.parent?.replace("master_", ""),
        sortIndex: index,
      };
    });

    try {
      await Promise.all(
        updates.map(async (item) => {
          const q = query(
            collection(db, "00_DeviceMasterTable"),
            where("masterID", "==", item.id),
            where("projectID", "==", currentProjectID)

          );
          const querySnapshot = await getDocs(q);

          if (!querySnapshot.empty) {
            const docRef = querySnapshot.docs[0].ref;
            await setDoc(docRef, {
              parentID: item.parentID,
              sortIndex: item.sortIndex,
            }, { merge: true });
          } else {
            // console.warn(`❌ masterID が ${item.id} のドキュメントが存在しません`);
          }
        })
      );
      alert("✅ 並び順を保存しました！");
    } catch (error) {
      // console.error("❌ 保存エラー:", error);
      alert("❌ 並び順の保存に失敗しました。");
    }
  };

  // 詳細編集画面へ遷移
  const handleEditButtonClick = () => {
    if (selectedID && selectedID.includes("master_")) {
      const masterID = selectedID.replace("master_", "");
      navigate(`/EditMaster/${masterID}`);
    } else {
      console.warn("選択されたノードIDが不正です:", selectedID);
    }
  };

  return (
    <>


      <div className="p-4">
        <h2 className="text-lg font-bold mb-4">ノードの並び順を編集</h2>
        <h4>ドラッグで表示順を自由に変更することができます</h4>
        <div ref={treeRef} id="jstree-edit" className="border p-2 rounded"></div>
        <div className="mt-4">
          <Button 
            className="save-button" 
            onClick={handleSaveOrder}>並び順を保存
          </Button>
          <button
            onClick={handleEditButtonClick}
            className="edit-button"
            disabled={isActionButtonDisabled}
          >
            編集する
          </button>
        </div>
      </div>
    </>
  );
};

export default TreeViewEdit;
